import { UploadOutlined } from "@ant-design/icons";

import { Button, Layout } from "antd";
import React, { createContext, useContext } from "react";
import { SubPageHeaderTitle } from "../../shared/SubPageHeaderTitle";

import MonthlyPerformanceStore from "./store/monthlyperformancestore";
import { observer } from "mobx-react-lite";
//import { SQuery } from "./SQuery";
//import { ProductionGrid } from "./ProductionGrid";
import { ProgressIndicator } from "@fluentui/react";
import { MonthlyProductionGrid } from "./MonthlyProductionGrid";
import { SQuery } from "./SQuery";

import { UploadWizardConatiner } from "./UploadWizardConatiner";
import { MonthlyQuery } from "./MonthlyQuery";
import MainStore from "../home/store/mainStore";
import { SaveQueryDialog } from "./SaveQueryDialog";
import { QueryListDrawer } from "./QueryListDrawer";
import { QueryTemplatePreview } from "./QueryTemplatePreview";
import { AdvanceQueryDialog } from "./AdvanceQueryDialog";
import { UploadStatus } from "./UploadStatus";

const { Content } = Layout;
const MonthlyPerformanceStoreCtx = createContext(MonthlyPerformanceStore);
const mainStoreCtx = createContext(MainStore);
export const MonthlyPerformanceBaseView = observer(
  ({ data: { permission } }) => {
    const monthlyPerformanceStore = useContext(MonthlyPerformanceStoreCtx);
    console.log("pops", permission);
    const mainStore = useContext(mainStoreCtx);
    mainStore.assetContextId = 1;
    mainStore.assetContextName = "NAOC";
    return (
      <Layout
        style={{
          background: "#fff",
          padding: "10px",
          borderTop: "2px solid #ffb300",
        }}
      >
        <Content>
          <div className="ms-Grid" dir="ltr">
            <div className="ms-Grid-row">
              <div className="ms-Grid-col ms-sm5">
                <SubPageHeaderTitle
                  title={`${monthlyPerformanceStore.gridHeaderText}`}
                />
              </div>
              <div className="ms-Grid-col ms-sm3">
                {monthlyPerformanceStore.isExporting && (
                  <ProgressIndicator
                    description="exporting, please wait..."
                    styles={{ root: { textAlign: "center" } }}
                  ></ProgressIndicator>
                )}
              </div>
              <div
                className="ms-Grid-col ms-sm4"
                style={{ textAlign: "right" }}
              >
                <Button
                  type="primary"
                  icon={<UploadOutlined />}
                  onClick={() => {
                    monthlyPerformanceStore.resetWorkflow();
                  }}
                >
                  Upload Monthly Production/Subsurface Data
                </Button>
              </div>
            </div>

            <div className="ms-Grid-row">
              <div className="ms-Grid-col ms-sm12">
                {" "}
                <MonthlyProductionGrid />
              </div>
            </div>
          </div>

          <div className="ms-Grid-row">
            <div className="ms-Grid-col ms-sm12">
              <SQuery />

              <UploadWizardConatiner />
             {/*  <MonthlyQuery /> */}
              <SaveQueryDialog />
              <QueryListDrawer />
              <QueryTemplatePreview />
              <AdvanceQueryDialog />
              <UploadStatus />
            </div>
          </div>
        </Content>
      </Layout>
    );
  }
);

